import React from 'react';

export default () => {
    return (
        <>
            <p>Here is ImportClaimsAndPayments.Home</p>
        </>
    )
}